import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

export const ImagePlaceholder = (props: IContentLoaderProps) => (
  <ContentLoader
    viewBox="0 0 860 957"
    backgroundColor="#e7f1fc"
    foregroundColor="#ffffff"
    {...props}
  >
    <rect x="0" y="0" rx="16" ry="16" width="100%" height="100%" />
  </ContentLoader>
);

export const MainPlaceholder = (props: IContentLoaderProps) => (
  <div className="placeholder business__main">
    <ContentLoader
      viewBox="0 0 860 400"
      backgroundColor="#e7f1fc"
      foregroundColor="#ffffff"
      {...props}
    >
      <rect x="0" y="0" rx="16" ry="16" width="80%" height="60" />
      <rect x="0" y="78" rx="16" ry="16" width="120" height="24" />
      <rect x="0" y="120" rx="16" ry="16" width="100%" height="20" />
      <rect x="0" y="158" rx="16" ry="16" width="100%" height="20" />
      <rect x="0" y="196" rx="16" ry="16" width="100%" height="20" />
    </ContentLoader>
  </div>
);

export const ContactInformationPlaceholder = (props: IContentLoaderProps) => (
  <div className="resolve-agent-details">
    <ContentLoader
      viewBox="0 0 400 542"
      backgroundColor="#e7f1fc"
      foregroundColor="#ffffff"
      width="100%"
      {...props}
    >
      <rect x="0" y="0" rx="16" ry="16" width="200" height="22" />
      <rect x="0" y="46" rx="16" ry="16" width="100%" height="264" />
      <rect x="0" y="334" rx="16" ry="16" width="350" height="28" />
      <rect x="0" y="374" rx="16" ry="16" width="290" height="22" />
      <rect x="0" y="408" rx="16" ry="16" width="320" height="22" />
      <rect x="0" y="442" rx="16" ry="16" width="190" height="22" />
      <rect x="0" y="488" rx="16" ry="16" width="150" height="42" />
      <rect x="166" y="488" rx="16" ry="16" width="150" height="42" />
    </ContentLoader>
  </div>
);

export const SectionTitlePlaceholder = (props: IContentLoaderProps) => (
  <ContentLoader
    viewBox="0 0 1257 46"
    backgroundColor="#e7f1fc"
    foregroundColor="#ffffff"
    {...props}
  >
    <rect x="0" y="0" rx="16" ry="16" width="550" height="46" />
  </ContentLoader>
);
